module.exports = __webpack_public_path__ + "img/Gif_web1.b8be80cc.gif";